<template>
  <body>
    <header>
      <NavBar class="fixed-top" />
    </header>
    <main class="vw-100 min-vh-100" :style="mainStyle">
      <slot />
      <slot name="bottom-main" />
    </main>
    <FooterContainer />
  </body>
</template>

<script>
import NavBar from '../Components/NavBar'
import FooterContainer from '../Components/FooterContainer.vue'

export default {
  components: { NavBar, FooterContainer },
  data() {
    return {
      mainPaddingTop: 50,
    }
  },
  computed: {
    mainStyle() {
      return {
        'background-color': 'var(--bs-gray-200)',
        'padding-top': `${this.mainPaddingTop}px`,
        '--bg-y-position': `-${this.mainPaddingTop}px`,
      }
    },
  },
  mounted() {
    this.mainPaddingTop =
      document.querySelector('header').firstChild.clientHeight
  },
}
</script>
<style lang="scss">
main {
  background-image: url('../../images/background.png');
  background-repeat: no-repeat;
  background-position: center
    clamp(-10vh, calc(2 * var(--bg-y-position)), -300px);

  background-size: contain;
}
</style>

